import React from "react";
import { getAttendance, markAttended } from "../actions/actions";
import Confirm from "../components/Confirm";
import moment from "moment-timezone";
import Clock from "../components/Clock";
import Loader from "../components/Loader";
import AttendanceItem from "../components/AttendanceItem";
import queue from "../helpers/checkinQueue";

class CheckIn extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			confirming: false,
			loading: true,
			input: "",
			spooftime: false
		};
		this.handleConfirm = this.handleConfirm.bind(this);
		this.handleCheckin = this.handleCheckin.bind(this);
		this.handleCheckinCancel = this.handleCheckinCancel.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleSettingsClick = this.handleSettingsClick.bind(this);

		queue.setup();

		const urlParams = new URLSearchParams(window.location.search);
		const ts = urlParams.get("ts");
		if (ts) {
			moment.tz.setDefault("UTC");
			let dateStringFmt = moment(ts).format("YYYY-MM-DDTHH:mm:ss.SSSZ");

			const tzDate = moment(ts).tz("America/Los_Angeles");
			let tz = tzDate.format("Z");

			// MomentJS Doesn't always catch DST as it should, so we'll check DST at noon as a backup.
			const DSTDate = moment(moment(tzDate).format("YYYY-MM-DD")).add(12, "hours").tz("America/Los_Angeles");
			// If timezone date misses DST, check the noon backup and adjust the offset.
			if ( !tzDate.isDST() && DSTDate.isDST() ) {
				tz = DSTDate.format("Z");
			}

			dateStringFmt = dateStringFmt.replace("+00:00", tz);

			this.state.spooftime = dateStringFmt;
		}

	}

	componentDidMount() {
		this._isMounted = true;
		this.refreshClasses();
		this.refreshInterval = window.setInterval(
			() => {
				this.refreshClasses();
			},
			60000
		);
		this.checkinQueueInterval = window.setInterval(
			() => {
				this.processCheckin();
			},
			5000
		);
	}

	processCheckin() {
		const currentCheckin = queue.current();
		if (currentCheckin) {
			const { memberId, classId, classDate } = currentCheckin;
			markAttended(memberId, classId, classDate).then(res => {
				if (!res.attended) {
					queue.add(currentCheckin);
					throw new Error("check-in failure requeued");
				}
			}).catch(err => {
				console.log(err);
			});
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
		clearInterval(this.refreshInterval);
	}

	refreshClasses() {
		getAttendance(this.state.spooftime).then(classes => {
			if (this._isMounted) {
				this.setState({
					classes: classes,
					currentClassIndex: 0,
					loading: false
				});
			}
		});
	}

	handleSettingsClick(event) {
		this.props.handleNav("login");
		event.preventDefault();
	}

	handleSearch(event) {
		const target = event.target;
		const value = target.value;

		this.setState({
			input: value
		});
	}

	handleConfirm(confirmingUser) {
		this.setState({
			confirming: true,
			confirmDetails: confirmingUser
		});
	}

	handleCheckinCancel() {
		this.setState({
			confirming: false,
			confirmDetails: {},
			input: ""
		});
	}

	handleCheckin() {
		const { memberId } = this.state.confirmDetails;

		queue.add(this.state.confirmDetails);

		const classIndex = this.state.currentClassIndex;
		const classes = this.state.classes;
		const currentClass = classes[classIndex];
		const enrolled = currentClass.enrolled;
		const memberIndex = enrolled.findIndex(
			function(member) {
				return member.id === this[0];
			},
			[memberId]
		);

		if (-1 < memberIndex) {
			enrolled[memberIndex].isCheckedIn = true;
			classes[classIndex].enrolled[memberIndex].isCheckedIn = true;
		}

		this.setState({
			confirming: false,
			confirmDetails: {},
			input: "",
			classes: classes
		});
	}

	getClassDescription(index) {
		if (this.state.classes && this.state.classes[index]) {
			const displayedClass = this.state.classes[index];
			return displayedClass.description;
		}
		return "Loading Class...";
	}

	getClassTime(index) {
		if (this.state.classes && this.state.classes[index]) {
			const displayedClass = this.state.classes[index];
			const startTime = moment(displayedClass.startTime).tz("America/Los_Angeles").format(
				"MMM Do YYYY - h:mm a"
			);
			const endTime = moment(displayedClass.endTime).tz("America/Los_Angeles").format("h:mm a");
			return `${startTime} - ${endTime}`;
		}
		return "";
	}

	getClassRemaining(index) {
		if (this.state.classes && this.state.classes[index]) {
			const displayedClass = this.state.classes[index];
			return `Remaining Slots: ${displayedClass.remaining}`;
		}
		return "";
	}

	getClassEnrolled(index) {
		if (this.state.classes && this.state.classes[index]) {
			const displayedClass = this.state.classes[index];
			return `Enrolled: ${displayedClass.enrolled.length}`;
		}
		return "";
	}

	getClassFocus(index) {
		if (this.state.classes && this.state.classes[index]) {
			const displayedClass = this.state.classes[index];
			const focusArr = [
				{ focus: "forge", points: displayedClass.forgePoints },
				{ focus: "fire", points: displayedClass.firePoints },
				{ focus: "flow", points: displayedClass.flowPoints }
			];
			const focusClass = Math.max.apply(
				Math,
				focusArr.map(o => {
					return o.points;
				})
			);
			const highestPoints = focusArr.find(
				function(focus) {
					const focusClass = this[0];
					return (focus.points === focusClass);
				},
				[focusClass]
			);
			return highestPoints.focus;
		}
		return "";
	}

	renderClassIcon(index) {
		const focus = this.getClassFocus(index);

		let classIcon;
		switch (focus) {
		case "fire":
			classIcon = (
				<div className="icon-title fire">
					<img
						src={process.env.PUBLIC_URL + "/images/icon-fire.svg"}
						alt="Fire"
						className="icon-circuit"
					/>
				</div>
			);
			break;
		case "forge":
			classIcon = (
				<div className="icon-title forge">
					<img
						src={process.env.PUBLIC_URL + "/images/icon-forge.svg"}
						alt="Forge"
						className="icon-circuit"
					/>
				</div>
			);
			break;
		case "flow":
			classIcon = (
				<div className="icon-title flow">
					<img
						src={process.env.PUBLIC_URL + "/images/icon-flow.svg"}
						alt="Flow"
						className="icon-circuit"
					/>
				</div>
			);
			break;
		default:
			classIcon = "";
		}

		return classIcon;
	}

	currentMoment() {
		return (this.state.spooftime) ? moment(this.state.spooftime) : moment();
	}


	renderAttendees(index, currentMoment) {
		if (this.state.classes && this.state.classes[index]) {
			const singleClass = this.state.classes[index];
			const classId = singleClass.id;
			const classDate = singleClass.classDate;
			const startTime = singleClass.startTime;
			const attendees = singleClass.enrolled.filter(d => {
				const fullName = `${d.lastName} ${d.firstName}`.toLowerCase();
				const findInput = this.state.input.toLowerCase().trim();
				return this.state.input === "" || fullName.includes(findInput);
			});

			return attendees.map(attendee => (
				<AttendanceItem
					key={attendee.id}
					classId={classId}
					classDate={classDate}
					firstName={attendee.firstName}
					lastName={attendee.lastName}
					memberId={attendee.id}
					handleConfirm={this.handleConfirm}
					isCheckedIn={attendee.isCheckedIn}
					startTime={startTime}
					spooftime={this.state.spooftime}
					currentMoment={currentMoment}
				/>
			));
		}
	}

	renderLoader() {
		let loader = "";
		if ( this.state.loading ) {
			loader = <Loader />;
		}
		return loader;
	}

	render() {
		if (this.state.confirming) {
			return (
				<div>
					<div className="registration-screen">
						<h1 className={this.getClassFocus(this.state.currentClassIndex)}>
							{this.getClassDescription(this.state.currentClassIndex)}
						</h1>
						<div className="class-information">
							<div className="class-teacher">
								<Clock />
							</div>
							<div className="class-time">
								{this.getClassTime(this.state.currentClassIndex)}
							</div>
						</div>
					</div>
					<Confirm
						details={this.state.confirmDetails}
						handleCheckin={this.handleCheckin}
						handleCheckinCancel={this.handleCheckinCancel}
					/>
				</div>
			);
		} else {
			return (
				<div>
					{this.renderLoader()}
					<div className="registration-screen">
						{this.renderClassIcon(this.state.currentClassIndex)}
						<h1 className={this.getClassFocus(this.state.currentClassIndex)}>
							{this.getClassDescription(this.state.currentClassIndex)}
						</h1>
						<div className="class-information">
							<div className="class-teacher">
								<Clock spooftime={this.state.spooftime} />
							</div>
							<div className="class-time">
								{this.getClassTime(this.state.currentClassIndex)}
							</div>
						</div>

						<div className="class-remaining">
							<div className="remaining">
								<p>
									{this.getClassRemaining(this.state.currentClassIndex)}
								</p>
							</div>
							<div className="enrolled">
								<p>
									{this.getClassEnrolled(this.state.currentClassIndex)}
								</p>
							</div>
						</div>

						<div className="class-search-name">
							<form action="#">
								<label htmlFor="search-name" className="wrap-search-name">
									<span className="screen-reader-text">Search your name</span>
									<img
										src={process.env.PUBLIC_URL + "/images/icon-search.svg"}
										alt="Search"
										className="icon-search"
									/>
									<input
										onChange={this.handleSearch}
										type="text"
										placeholder="Search your name"
										id="search-name"
									/>
								</label>
							</form>
						</div>

						<div className="class-list">
							<ul className="student-list">
								{this.renderAttendees(this.state.currentClassIndex, this.currentMoment())}
							</ul>
						</div>
					</div>
					<a
						href="#noanchor"
						onClick={this.handleSettingsClick}
						className="admin-log-in"
					>
						<img
							src={process.env.PUBLIC_URL + "/images/icon-gear.svg"}
							alt="Gear icon"
							className="icon-gear"
						/>
					</a>
				</div>
			);
		}
	}
}
export default CheckIn;



// WEBPACK FOOTER //
// ./src/layouts/CheckIn.js